import { registerCatalog } from '@kidova/i18n';
import type { AppLocale } from '../lib/preferences';
import { CATALOGS } from './index';

const loaded = new Set<AppLocale>();

/**
 * Every language (the dashboard's copy and the component library's) loads on demand, so each
 * parent downloads only their own (§22.3 initial JS budget); public/boot.js starts the download
 * before the app code runs. Nothing renders in a locale until this resolves.
 */
export async function loadLocale(locale: AppLocale): Promise<void> {
  if (loaded.has(locale)) return;
  const [app, ui] =
    locale === 'en'
      ? await Promise.all([import('./en.json'), import('@kidova/i18n/catalogs/en.json')])
      : locale === 'de'
        ? await Promise.all([import('./de.json'), import('@kidova/i18n/catalogs/de.json')])
        : await Promise.all([import('./ar.json'), import('@kidova/i18n/catalogs/ar.json')]);
  Object.assign(CATALOGS[locale], app.default);
  registerCatalog(locale, ui.default);
  loaded.add(locale);
}
